import { createFileRoute } from '@tanstack/react-router';

// relative imports
import MonitoringPage from '../../components/monitoring/MonitoringPage';
import LoadingPage from '../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute('/_authenticated/monitoring')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: MonitoringPage,
  staticData: {
    configPageId: 'monitoring',
    meta: {
      title: 'Monitoring | Ledgible',
    },
  },
});
